import { VacancyDetail } from '@/interfaces/vacancy'
import useIsRay from '@/hooks/useIsRay'
import useWithinPageNav from '@/hooks/navigation/useWithinPageNav'
import { GRID, routes } from '@/lib/constants'
import Section from '@/layouts/section'
import Tabs from '@/components/tabs'
import GeneralInfoTitle from '@/components/vacancy-detail/general-title'
import GeneralInfoContent from '@/components/vacancy-detail/info-content'
import VacancyDetailInfo from '../content'
import Image from '@/components/image'
import { ButtonLinkPrimaryTextAndArrow } from '@/components/button'
import CustomerLabelsList from '@/components/vacancy-detail/customer-labels'

const Vacancy = ({ vacancy }: { vacancy: VacancyDetail }) => {
  const {
    activeElementIndex,
    handleWithinPageNav,
    handleChangeActiveElemIndex,
  } = useWithinPageNav({ numOfFormElements: vacancy.content.length || 0 })
  const isRay = useIsRay()

  const sollicitatiePath = isRay
    ? `${routes.ray.vacancies}/${vacancy.uid ?? ''}/sollicitatie`
    : `${routes.rvdb.vacancies}/${vacancy.uid ?? ''}/sollicitatie`

  const filteredContent = vacancy.content.filter(
    (single) => !!single.description && single.title !== 'Google description'
  )

  const tabsContent = filteredContent?.map((single) => single.title)

  return (
    <Section className={`vacancyDetails ${GRID}`}>
      <GeneralInfoTitle
        title={vacancy.title}
        publicationStatusId={vacancy.publicationStatusId}
      />
      <GeneralInfoContent
        location={vacancy.location}
        salaryValue={vacancy.salaryValue}
        hoursPerWeek={vacancy.hoursPerWeek}
      />
      <Tabs
        activeElementIndex={activeElementIndex}
        handleChangeActiveElemIndex={handleChangeActiveElemIndex}
        content={tabsContent}
        className="!hidden md:!flex mb-8 md:mb-20"
      />
      {vacancy.photoFileName && (
        <div className="col-span-full row-start-3 md:row-auto lg:col-start-1 lg:col-end-5">
          <Image
            src={vacancy.photoFileName}
            alt={vacancy.title ?? ''}
            width="256px"
            height="145px"
            objectFit="contain"
            className='vacancyDetails__logo' 
          />
        </div>
      )}
      <CustomerLabelsList customerLabels={vacancy.customerLabels ?? []} />
      <ButtonLinkPrimaryTextAndArrow
        version="c"
        href={sollicitatiePath}
        className="col-span-full row-start-2 md:row-auto lg:col-start-1 lg:col-end-5"
      >
        Solliciteren
      </ButtonLinkPrimaryTextAndArrow>
      <VacancyDetailInfo
        content={filteredContent}
        bannerImage={vacancy.bannerImage}
        activeElementIndex={activeElementIndex}
        handleWithinPageNav={handleWithinPageNav}
        handleChangeActiveElemIndex={handleChangeActiveElemIndex}
        sollicitatiePath={sollicitatiePath}
      />
    </Section>
  )
}

export default Vacancy
